import {
  get
} from '../axios'

class Common {
  async getSalsByName(param) {
    const res = await get('/Common/GetSalsemanListByName', param)
    return res
  }
  async getMutiBranchSalsByName(param) {
    const res = await get('/Common/GetMutiBranchSalsemanListByName', param)
    return res
  }

}
export default new Common()